import { render } from "./PreStartSection.vue?vue&type=template&id=5d4ac0ca"
import script from "./PreStartSection.vue?vue&type=script&lang=js"
export * from "./PreStartSection.vue?vue&type=script&lang=js"

import "./PreStartSection.vue?vue&type=style&index=0&id=5d4ac0ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__